import React, { useState,useEffect } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function ProductAdsRequestPage() {
    const ID = Cookies.get("log_id");
    const [products,setProducts] = useState([]);
    function Fetch_Products() {
        axios.get(`${url.path}/fetch_products/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var prod = res.data.products;
                setProducts([])
                prod.map((p)=>{
                    setProducts((prevState) =>[
                        ...prevState, p
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });    
    }
    useEffect(() =>{
        Fetch_Products();
    }, [])
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    const [product,setProduct] = useState("");
    const [description,setDescription] = useState("");
    const [duration,setDuration] = useState("");
    const [start,setStart] = useState("");
    const [end,setEnd] = useState("");
    const [file,setFile] = useState(null);
    const navigate = useNavigate();
    function SubmitRequest(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('product',product);
        formdata.append('description',description);
        formdata.append('duration',duration);
        formdata.append('start',start);
        formdata.append('end',end);
        formdata.append('file',file);
        axios.post(`${url.path}/product_ads_request_company/`,formdata)
        .then((res) =>{
            if (res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Product Ads Submitted Successfully..'
                })
                navigate("/all_ads_company_page");
            }
        }).catch((err) => {
            console.log("ERROR", err);
            if(!err.response.data.status){
                Swal.fire({
                  icon: "error",
                  title: `${err.response.data.message}`,
                });
              }
          });  
    }
    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Add Product Ads</h1>
                </div>
                <br />
                <form onSubmit={SubmitRequest}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Product</label>
                            <select value={product} onChange={(e) =>setProduct(e.target.value)}>
                                <option>--Select--</option>
                                {products && products.map((p) =>(
                                    <option value={p.id}>{p.Name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <input type="text" value={description} onChange={(e) =>setDescription(e.target.value)}  />
                        </div>
                        <div className="form-group">
                            <label>Duration</label>
                            <input type="text" value={duration} onChange={(e) =>setDuration(e.target.value)}  />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Start Date</label>
                            <input type="date" value={start} onChange={(e) =>setStart(e.target.value)}  />
                        </div>
                        <div className="form-group">
                            <label>End Date</label>
                            <input type="date" value={end} onChange={(e) =>setEnd(e.target.value)}  />
                        </div>
                        <div className="form-group">
                            <label>Poster/Video</label>
                            <input type="file" id="image" accept="image/*,video/*" onChange={(e) =>setFile(e.target.files[0])} />
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Request</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default ProductAdsRequestPage;